import { GAME_BY_ID } from '@ruby-cms/shared';
import { Money, When } from '../components/format';
import { CONFIG_NAME, JACKPOT_ACTION, WAGERING_SOURCE } from '../components/labels';
import { lodeSummary } from '../components/LodeChange';

// Lenh CMS gui sang he A: kieu va dong tom tat dung chung cho trang chi tiet lenh va cac trang tao lenh.
// Trang danh sach "Hang lenh" va tab "Lenh CMS" o trang nguoi choi da bo (khach 2026-10-02); lenh loi
// van bao vao nhom Telegram quan tri (jobs/ops.ts).

export type Command = {
  id: string;
  key: string;
  type: 'MONEY' | 'LOCK' | 'CONFIG' | 'RESULT' | 'EDIT' | 'FLAG' | 'PLAYER_FLAG' | 'PASSWORD' | 'REFUND' | 'TRANSFER' | 'JACKPOT' | 'CHAT_DELETE' | 'CHAT_SEND' | 'LODE' | 'VIP' | 'COOLOFF' | 'POOL_RESET';
  status: string;
  isProtected: boolean;
  targetUserId: number | null;
  payload: Record<string, unknown>;
  reason: string;
  makerId: string;
  makerName: string;
  approverName: string | null;
  decisionNote: string | null;
  result: Record<string, unknown> | null;
  attempts: number;
  lastError: string | null;
  sourceType: string | null;
  sourceId: string | null;
  createdAt: string;
  completedAt: string | null;
};

export function commandSummary(c: Command) {
  if (c.type === 'MONEY') {
    const m = <Money v={Number(c.payload.delta)} signed unit={c.payload.cot === 'xu' ? 'xu' : true} />;
    if (c.payload.vong_cuoc) return <>{m} <span className="muted">(tính vòng cược: {WAGERING_SOURCE[String(c.payload.vong_cuoc)] ?? String(c.payload.vong_cuoc)})</span></>;
    // a vin credit without the wagering mark: the Khong tinh choice of the money dialog (owner 2026-10-05)
    return Number(c.payload.delta) > 0 && c.payload.cot !== 'xu' ? <>{m} <span className="muted">(không tính vòng cược)</span></> : m;
  }
  if (c.type === 'TRANSFER') {
    const p = c.payload;
    return <>#{String(p.tu_user_id)} → #{String(p.den_user_id)}: <Money v={Number(p.so_tien)} unit />{Number(p.phi) ? <> (phí <Money v={Number(p.phi)} />)</> : null}</>;
  }
  if (c.type === 'LOCK') return c.payload.khoa ? 'Khóa tài khoản' : 'Mở khóa';
  if (c.type === 'FLAG') return c.payload.la_test ? 'Đánh dấu tài khoản thử' : 'Bỏ đánh dấu tài khoản thử';
  if (c.type === 'CHAT_DELETE') return 'Xóa tin chat #' + String(c.payload.id);
  if (c.type === 'CHAT_SEND') return 'Tin hệ thống vào chat ' + String(c.payload.game) + ': ' + String(c.payload.noi_dung);
  if (c.type === 'PLAYER_FLAG') {
    const v = c.payload.gia_tri;
    if (c.payload.co === 'rut') return v ? 'Dừng rút tiền' : 'Cho rút tiền lại';
    if (c.payload.co === 'chat') return Number(v) ? <>Cấm chat đến <When v={Number(v)} /></> : 'Bỏ cấm chat';
    if (c.payload.co === 'mkt') return v ? 'Đánh dấu tài khoản MKT' : 'Bỏ đánh dấu tài khoản MKT';
    return Array.isArray(v) && v.length ? 'Khóa game: ' + v.join(', ') : 'Bỏ khóa mọi game';
  }
  if (c.type === 'PASSWORD') return c.payload.loai === 'rut' ? (c.payload.bam ? 'Đặt mật khẩu rút' : 'Xóa mật khẩu rút') : 'Đặt lại mật khẩu đăng nhập';
  if (c.type === 'VIP') return `Điểm VIP của ${Array.isArray(c.payload.ds) ? c.payload.ds.length : 0} người chơi`;
  if (c.type === 'POOL_RESET') return c.payload.gid ? 'Reset quỹ ' + String(c.payload.gid) + ' về mức gốc' : 'Reset tất cả quỹ về mức gốc';
  if (c.type === 'COOLOFF') return Number(c.payload.den) ? <>Tự khóa đến <When v={new Date(Number(c.payload.den)).toISOString()} /></> : 'Gỡ tự khóa';
  if (c.type === 'RESULT') {
    const p = c.payload;
    if (p.poker === true) {
      if (p.hanh_dong === 'huy') return 'Xóa lệnh poker #' + String(p.id);
      if (p.che_do === 'bai') return 'Chỉ định bài bàn ' + String(p.ban_id);
      return (p.ket_qua === 'thua' ? 'Thua' : 'Thắng') + ' bàn ' + String(p.ban_id);
    }
    return p.hanh_dong === 'huy' ? 'Hủy lệnh #' + String(p.id) : 'Đặt kết quả ' + String(p.game_id);
  }
  if (c.type === 'EDIT') {
    return 'Sửa ' + String(c.payload.nguon) + ' #' + String(c.payload.ref);
  }
  if (c.type === 'JACKPOT') {
    const p = c.payload;
    const what = p.hanh_dong === 'cong' ? <Money v={Number(p.delta)} signed />
      : p.hanh_dong === 'dat' || p.hanh_dong === 'moc' ? <Money v={Number(p.gia)} /> : null;
    return <>{JACKPOT_ACTION[String(p.hanh_dong)] ?? String(p.hanh_dong)} hũ {String(p.ten)}{what ? <>: {what}</> : null}</>;
  }
  if (c.type === 'REFUND') return 'Hoàn cả ván ' + String(c.payload.ma_van) + ' ' + (GAME_BY_ID.get(String(c.payload.game))?.name ?? String(c.payload.game));
  if (c.type === 'LODE') return lodeSummary(c.payload);
  return CONFIG_NAME[String(c.payload.ten)] ?? `Cấu hình ${String(c.payload.ten)}`;
}
